/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { communityLikeControllerFindByCommunityId } from '../fn/community-like/community-like-controller-find-by-community-id';
import { CommunityLikeControllerFindByCommunityId$Params } from '../fn/community-like/community-like-controller-find-by-community-id';
import { communityLikeControllerFindById } from '../fn/community-like/community-like-controller-find-by-id';
import { CommunityLikeControllerFindById$Params } from '../fn/community-like/community-like-controller-find-by-id';
import { communityLikeControllerFindByUserId } from '../fn/community-like/community-like-controller-find-by-user-id';
import { CommunityLikeControllerFindByUserId$Params } from '../fn/community-like/community-like-controller-find-by-user-id';
import { communityLikeControllerSearchOffset } from '../fn/community-like/community-like-controller-search-offset';
import { CommunityLikeControllerSearchOffset$Params } from '../fn/community-like/community-like-controller-search-offset';
import { communityLikeControllerUnLiked } from '../fn/community-like/community-like-controller-un-liked';
import { CommunityLikeControllerUnLiked$Params } from '../fn/community-like/community-like-controller-un-liked';
import { CommunityLikeDto } from '../models/community-like-dto';

@Injectable({ providedIn: 'root' })
export class CommunityLikeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `communityLikeControllerSearchOffset()` */
  static readonly CommunityLikeControllerSearchOffsetPath = '/api/community-like/search/offset';

  /**
   * 커뮤니티 좋아요 오프셋 기반 조회.
   *
   * 커뮤니티 좋아요를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityLikeControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityLikeControllerSearchOffset$Response(params: CommunityLikeControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunityLikeDto>>> {
    return communityLikeControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 좋아요 오프셋 기반 조회.
   *
   * 커뮤니티 좋아요를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityLikeControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityLikeControllerSearchOffset(params: CommunityLikeControllerSearchOffset$Params, context?: HttpContext): Observable<Array<CommunityLikeDto>> {
    return this.communityLikeControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CommunityLikeDto>>): Array<CommunityLikeDto> => r.body)
    );
  }

  /** Path part for operation `communityLikeControllerFindByUserId()` */
  static readonly CommunityLikeControllerFindByUserIdPath = '/api/community-like/my';

  /**
   * 로그인 회원 커뮤니티 좋아요 조회.
   *
   * 로그인한 회원의 커뮤니티 좋아요를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityLikeControllerFindByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityLikeControllerFindByUserId$Response(params?: CommunityLikeControllerFindByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunityLikeDto>>> {
    return communityLikeControllerFindByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * 로그인 회원 커뮤니티 좋아요 조회.
   *
   * 로그인한 회원의 커뮤니티 좋아요를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityLikeControllerFindByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityLikeControllerFindByUserId(params?: CommunityLikeControllerFindByUserId$Params, context?: HttpContext): Observable<Array<CommunityLikeDto>> {
    return this.communityLikeControllerFindByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CommunityLikeDto>>): Array<CommunityLikeDto> => r.body)
    );
  }

  /** Path part for operation `communityLikeControllerFindById()` */
  static readonly CommunityLikeControllerFindByIdPath = '/api/community-like/{id}';

  /**
   * 커뮤니티 좋아요 ID 기반 조회.
   *
   * 커뮤니티 좋아요를 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityLikeControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityLikeControllerFindById$Response(params: CommunityLikeControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunityLikeDto>> {
    return communityLikeControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 좋아요 ID 기반 조회.
   *
   * 커뮤니티 좋아요를 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityLikeControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityLikeControllerFindById(params: CommunityLikeControllerFindById$Params, context?: HttpContext): Observable<CommunityLikeDto> {
    return this.communityLikeControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommunityLikeDto>): CommunityLikeDto => r.body)
    );
  }

  /** Path part for operation `communityLikeControllerUnLiked()` */
  static readonly CommunityLikeControllerUnLikedPath = '/api/community-like/{id}';

  /**
   * 커뮤니티 좋아요 삭제.
   *
   * 커뮤니티 좋아요를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityLikeControllerUnLiked()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityLikeControllerUnLiked$Response(params: CommunityLikeControllerUnLiked$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunityLikeDto>> {
    return communityLikeControllerUnLiked(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 좋아요 삭제.
   *
   * 커뮤니티 좋아요를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityLikeControllerUnLiked$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityLikeControllerUnLiked(params: CommunityLikeControllerUnLiked$Params, context?: HttpContext): Observable<CommunityLikeDto> {
    return this.communityLikeControllerUnLiked$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommunityLikeDto>): CommunityLikeDto => r.body)
    );
  }

  /** Path part for operation `communityLikeControllerFindByCommunityId()` */
  static readonly CommunityLikeControllerFindByCommunityIdPath = '/api/community-like/community/{communityId}';

  /**
   * 커뮤니티 게시글 ID 기반 조회.
   *
   * 좋아요를 게시글 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityLikeControllerFindByCommunityId()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityLikeControllerFindByCommunityId$Response(params: CommunityLikeControllerFindByCommunityId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunityLikeDto>>> {
    return communityLikeControllerFindByCommunityId(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 게시글 ID 기반 조회.
   *
   * 좋아요를 게시글 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityLikeControllerFindByCommunityId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityLikeControllerFindByCommunityId(params: CommunityLikeControllerFindByCommunityId$Params, context?: HttpContext): Observable<Array<CommunityLikeDto>> {
    return this.communityLikeControllerFindByCommunityId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CommunityLikeDto>>): Array<CommunityLikeDto> => r.body)
    );
  }

}
